import { DEFAULT_TAB_CONFIG } from "../../../../../../stores/use-people-store";

const DEFAULT_DATA = {
  config: {
    showTabs: false,
    columns: 3,
    pagination: "infinite",
    cardBorderRadius: 3,
    titleFieldId: "",
    footerFieldId: "",
    tabs: {
      t38kX5BODZ: { ...DEFAULT_TAB_CONFIG },
    },
  },
  tabs: [
    {
      id: "t38kX5BODZ",
      name: "Tab 1",
      position: 0,
    },
  ],
};

export const PEOPLE_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "card",
    },
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "list",
    },
  },
];

export const buildTemplate = (variant, borderRadius) => ({
  ...DEFAULT_DATA,
  config: {
    ...DEFAULT_DATA.config,
    variant,
    cardBorderRadius: borderRadius,
  },
});
